import React from "react";
import "bulma/css/bulma.css";
import "../App.css";
import { useTranslation } from "react-i18next";
import AOS from "aos";
import "aos/dist/aos.css";

AOS.init();
function About() {
  var today = new Date();
  var birthDate = new Date("08/08/1999");
  var age = today.getFullYear() - birthDate.getFullYear();
  if (today.getMonth() < 7) {
    age--;
  }
  const { t } = useTranslation();
  return (
    <section id="about" className="section is-medium mt-6">
      <div className="content has-text-centered">
        <h1 className="block is-size-1 has-text-centered mt-6 underline">
          <span> {t("tr.about")}</span>
        </h1>
      </div>
      <div className="columns">
        <div
          className="column is-mobile"
          data-aos="fade-right"
          data-aos-duration="3000"
        >
          <figure className="image container">
            <img
              src={require("../images/photo.jpg")}
              className="is-rounded"
              alt="Profile ..."
            />
          </figure>
        </div>
        <div className="column is-two-thirds is-mobile ml-6">
          <p
            className="subtitle is-size-5 has-text-weight-semibold mt-6  is-mobile"
            style={{ lineHeight: "4.2rem" }}
          >
            {t("about.name")} {age} {t("about.age")}
            <br />⚡ {t("about.l1")} <br />⚡ {t("about.l2")} <br />⚡{" "}
            {t("about.l3")} <br />⚡ {t("about.l4")} <br />
          </p>
        </div>
      </div>
    </section>
  );
}

export default About;
